// Interfaces
export interface Integration {
  apiKey?: string;
  apiKeyHeaderName?: string;
  authEndpointUrl?: string;
  authPassword?: string;
  authType: AuthType;
  authUsername?: string;
  contactInformation: ContactInformation;
  customers: CustomerInfo[];
  enabled: boolean;
  id: number;
  integrationType: string;
  objectStrategy?: string;
  metrics?: Metric;
  oauthClientId: string;
  oauthClientSecret: string;
  oauthGrantType: string;
  pushUrl: string;
  vendorName: string;
  vendorKey: string;
}

export interface IntegrationCategory {
  name: string;
  enabled: boolean;
}

export interface AuthType {
  id: number;
  authMethod: string;
}

export interface ObjectStrategy {
  id: number;
  strategyName: string;
  description: string;
}

export interface Metric {
  id: number;
  distance: string;
  time: string;
}

export interface CustomerInfo {
  customerKey: string;
  id: number;
  stackName: string;
}

export interface ContactInformation {
  contactEmail: string;
  contactName: string;
  contactPhone: string;
}

export interface IntegrationTypeMetaData {
  name: string;
  urlPath: string;
  queryParam: string;
}

// Constants

export const OPERATIONAL_META_DATA: Record<string, IntegrationTypeMetaData> = {
  CAD: { name: 'CAD', urlPath: 'cad', queryParam: 'CAD' },
  FLEET: { name: 'Fleet', urlPath: 'fleet', queryParam: 'FLEET' },
};

export const SAFETY_META_DATA: Record<string, IntegrationTypeMetaData> = {
  SAFETY: { name: 'SAFETY', urlPath: 'safety', queryParam: 'SAFETY' },
};

export const BUSINESS_META_DATA: Record<string, IntegrationTypeMetaData> = {};

export const SECURITY_META_DATA: Record<string, IntegrationTypeMetaData> = {};

export const ECO_META_DATA: Record<string, IntegrationTypeMetaData> = {};

export const INTEGRATION_CATEGORY_LIST = {
  OPERATIONAL: { name: 'Operational', enabled: true, metaData: OPERATIONAL_META_DATA },
  SAFETY: { name: 'Safety', enabled: false, metaData: SAFETY_META_DATA },
  BUSINESS: { name: 'Business', enabled: false, metaData: BUSINESS_META_DATA },
  SECURITY: { name: 'Security', enabled: false, metaData: SECURITY_META_DATA },
  ECO: { name: 'ECO', enabled: false, metaData: ECO_META_DATA },
} as const;

export const API_URL_PATHS = Object.values(INTEGRATION_CATEGORY_LIST).map((type) => type.name);

export const DEFAULT_API_KEY_HEADER_NAME = 'apikey';

export const DISTANCE_OPTIONS = ['kilometer', 'mile'];
export const TIME_OPTIONS = ['second', 'minute', 'hour'];
